module.exports = __webpack_public_path__ + "static/media/empty_amber.2672f715.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/empty_amber.svg
// module id = 1104
// module chunks = 2